import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import WebsiteLayoutWS from '../WebsiteLayoutWS';
import FeatureElement from '../components/FeatureElement';
import CallToAction from '../components/CallToAction';
import HeaderPage from '../components/HeaderPage';

const FeaturesWs = ({ businessData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <WebsiteLayoutWS>
      <Helmet>
        <title>CHEK UP - {t('featuresTitle')}</title>
        <meta
          name="description"
          content={t('metaDescription')}
        />
      </Helmet>
      <HeaderPage
        title={t('featuresTitle')}
        subtitle={t('featuresSubtitle')}
        caption={t('featuresCaption')}
      />
      <FeatureElement
        orientation="lr"
        title={t('features1Title')}
        description={t('features1Description')}
        image="/assets/chekup/Features1.png"
        linkLabel={t('features1Link')}
        linkUrl="/fonctionnalites/precision-preparation"
        listItems={[
          {
            title: t('features1Item1Title'),
            description: t('features1Item1Desc'),
          },
          {
            title: t('features1Item2Title'),
            description: t('features1Item2Desc'),
          },
        ]}
      />
      <FeatureElement
        orientation="rl"
        title={t('features2Title')}
        description={t('features2Description')}
        image="/assets/chekup/Features2.png"
        linkLabel={t('features2Link')}
        linkUrl="/fonctionnalites/flux-de-travail"
        listItems={[
          {
            title: t('features2Item1Title'),
            description: t('features2Item1Desc'),
          },
          {
            title: t('features2Item2Title'),
            description: t('features2Item2Desc'),
          },
          {
            title: t('features2Item3Title'),
            description: t('features2Item3Desc'),
          },
        ]}
      />
      <FeatureElement
        orientation="lr"
        title={t('features3Title')}
        description={t('features3Description')}
        image="/assets/chekup/Features3.png"
        linkLabel={t('features3Link')}
        linkUrl="/fonctionnalites/acces-information"
        listItems={[
          {
            title: t('features3Item1Title'),
            description: t('features3Item1Desc'),
          },
          {
            title: t('features3Item2Title'),
            description: t('features3Item2Desc'),
          },
          {
            title: t('features3Item3Title'),
            description: t('features3Item3Desc'),
          },
        ]}
      />

      <CallToAction
        title={t('ctaTitle')}
        description={t('ctaDescription')}
        primaryButtonText={t('ctaPrimaryButton')}
        primaryButtonLink="/onboard"
        secondaryButtonText={t('ctaSecondaryButton')}
        secondaryButtonLink="/demo"
      />
    </WebsiteLayoutWS>
  );
};

export default FeaturesWs;
